import React from 'react';
import PropTypes from 'prop-types';

import { Box as MUIBox } from '@material-ui/core';

export const Box = props => <MUIBox {...props} />;

Box.propTypes = {
  alignItems: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  display: PropTypes.string,
  flexDirection: PropTypes.string,
  justifyContent: PropTypes.string,
  m: PropTypes.number // eslint-disable-line id-length
};

export default Box;
